const Questions = () => {
    return (
        <section className="font-link p-5 bg-secondary text-light text-center" id="question">
            <div className="container">
                <h1 className="fw-bold pb-5 pt-5">سوالات پر تکرار</h1>

                <div id="accordion" className="accordion accordion-flush text-light bg-dark">
                    <div className="accordion-item card text-light bg-dark">
                        <div className="accordion-header card-header text-light bg-dark" id="headingOne">
                            <h5 className="mb-0">
                                <button
                                    className="accordion-button d-grid collapsed text-light bg-secondary text-center fw-bold"
                                    type="button"
                                    data-bs-toggle="collapse"
                                    data-bs-target="#collapseOne">
                                    چگونه در سایت عضو بشوم؟
                                </button>
                            </h5>
                        </div>

                        <div id="collapseOne" className="accordion-collapse collapse card-body"
                             data-parent="#accordion">
                            <div className="accordion-body text-md-end text-center text-light bg-dark">
                                عضویت در سامانه خدمات پزشکی فراد در حال حاضر میسر نیست و فقط اعضایی که از طریق مدیران
                                شرکت در سایت عضو شده اند می توانند وارد پنل خود شوند. به زودی امکان عضویت عموم مردم در
                                این سامانه فراهم خواهد شد.
                            </div>
                        </div>
                    </div>
                    <div className="accordion-item card bg-dark text-light">
                        <div className="accordion-header card-header" id="headingTwo">
                            <h5 className="mb-0">
                                <button
                                    className="accordion-button d-grid collapsed text-center fw-bold bg-secondary text-light"
                                    data-bs-toggle="collapse"
                                    data-bs-target="#collapseTwo">
                                    چگونه می توانم با سیستم خدمات پزشکی فراد همکاری کنم؟
                                </button>
                            </h5>
                        </div>

                        <div id="collapseTwo" className="accordion-collapse collapse card-body"
                             data-parent="#accordion">
                            <div className="accordion-body text-md-end text-center bg-dark text-light">
                                شما می توانید از طریق اپلیکیشن موبایلی که به زودی در همین سایت و اپ استور های معتبر
                                منتشر خواهد شد با توجه به نوع همکاری خود (پزشک، منشی یا بیمار) در سامانه ثبت نام کنید و
                                از خدمات این سامانه استفاده کنید.
                            </div>
                        </div>
                    </div>
                    <div className="accordion-item card bg-dark text-light">
                        <div className="accordion-header card-header" id="headingThree">
                            <h5 className="mb-0">
                                <button
                                    className="accordion-button d-grid collapsed text-center bg-secondary text-light fw-bold"
                                    data-bs-toggle="collapse"
                                    data-bs-target="#collapseThree">
                                    آیا میتوانم در "فراد" مشغول به کار شوم؟
                                </button>
                            </h5>
                        </div>

                        <div id="collapseThree" className="accordion-collapse collapse card-body"
                             data-parent="#accordion">
                            <div className="accordion-body text-md-end text-center">
                                شرکت پزشکی-نرم افزاری فراد همیشه آماده جذب نیروهای فعال و با انگیزه در زمینه های برنامه
                                نویسی و مدیریت تیم های برنامه نویسی، بخش های بازاریابی و فروش، تیم های پشتیبانی، مشاورین
                                پزشکی و سلامت و همچنین بخش های حسابداری و اقتصادی می باشد. شما میتوانید با مراجعه به
                                قسمت <a className="font-link fw-bolder" href="#jobs">فرصت های شغلی</a> رزومه خود را برای ما ارسال کنید و همکار ما در بخش
                                نیروی انسانی در
                                اسرع وقت با شما تماس خواهند گرفت.
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
}
export default Questions;